import { render, staticRenderFns } from "./bsp-dicts-ref.vue?vue&type=template&id=45529fc0&scoped=true&"
import script from "./bsp-dicts-ref.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-ref.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-ref.vue?vue&type=style&index=0&id=45529fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45529fc0",
  null
  
)

export default component.exports